export default {
  title: 'Gerar QR Codes',

  name: 'Nome do lote',
  amount: 'Quantidade de QR Codes'
}
